/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createInvestmentAccountGetResponseFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeInvestmentAccountPatchRequest, type InvestmentAccountGetResponse, type InvestmentAccountPatchRequest, type ProblemDetails } from '../../models';
// @ts-ignore
import { TickersRequestBuilderNavigationMetadata, TickersRequestBuilderRequestsMetadata, type TickersRequestBuilder } from './tickers';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /investmentaccounts/{investmentAccountId}
 */
export interface WithInvestmentAccountItemRequestBuilder extends BaseRequestBuilder<WithInvestmentAccountItemRequestBuilder> {
    /**
     * The tickers property
     */
    get tickers(): TickersRequestBuilder;
    /**
     * Deletes an account
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 404 status code
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Retrieves a specific account
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<InvestmentAccountGetResponse>}
     * @throws {ProblemDetails} error when the service returns a 404 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<InvestmentAccountGetResponse | undefined>;
    /**
     * Updates an account
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 404 status code
     */
     patch(body: InvestmentAccountPatchRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Deletes an account
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Retrieves a specific account
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Updates an account
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPatchRequestInformation(body: InvestmentAccountPatchRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithInvestmentAccountItemRequestBuilderUriTemplate = "{+baseurl}/investmentaccounts/{investmentAccountId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithInvestmentAccountItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithInvestmentAccountItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    tickers: {
        requestsMetadata: TickersRequestBuilderRequestsMetadata,
        navigationMetadata: TickersRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithInvestmentAccountItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithInvestmentAccountItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
    get: {
        uriTemplate: WithInvestmentAccountItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createInvestmentAccountGetResponseFromDiscriminatorValue,
    },
    patch: {
        uriTemplate: WithInvestmentAccountItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeInvestmentAccountPatchRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
